@if (showBanner) {
  <div class="error-banner-overlay">
    <div class="error-banner-container">
      <div class="error-banner-content">
        <!-- Error Icon -->
        <div class="error-icon">
          <img src="assets/img/maintenance.png" alt="Service unavailable" width="200" height="auto">
        </div>
        <!-- Error Title -->
        <h1 class="error-title">Service unavailable</h1>
        <!-- Error Message -->
        <div class="error-message">
          <p>Try refreshing the page or going back and attempting the action again.</p>
          <p>If this problem persists, please contact our <a [href]="'mailto:' + supportEmail" class="support-link">Support</a>.</p>
        </div>
        <!-- Refresh Button -->
        <div class="error-button-container">
          <lib-utmc-button
            [color]="'primary'"
            (onClick)="onRefreshClick()">
            Refresh
          </lib-utmc-button>
        </div>
      </div>
    </div>
  </div>
}
